import { Archive, Bell, Cog, NotepadText, Plus, Tag, Trash2 } from "lucide-react";
import { createContext, useContext, useMemo, useState } from "react";
import { cn } from "../util/base.util";
import Labels from "../pages/labels";
import { AuthContext } from "./auth.context";

type ISidebarContext = {
    open: boolean;
    setOpen: (b: boolean) => void;
    sel: number;
    setSel: (i: number) => void;
}

export const SidebarContext = createContext<ISidebarContext>({
    open: false,
    setOpen: () => {},
    sel: 0,
    setSel: () => {}
});

export function SidebarProvider({children}: {
    children: React.ReactNode;
}) {
    const auth = useContext(AuthContext);

    const [sel, setSel] = useState(0);
    const [open, setOpen] = useState(false);
    

    const menu = useMemo<{
        value: React.ReactNode;
        callback?: () => void;
        element?: React.ReactNode;
        label?: string;
    }[]>(() => {

        return [
            {
                value: (<><NotepadText size={18} /> Notes</>),
            },
            {
                value: (<><Plus size={18} /> Create new label</>),
                element: (<Labels />),
            }
        ];
    }, [auth.user]);

    function Sel(i: number) {
        if (menu[i].callback) {
            //@ts-ignore
            menu[i].callback();
        } else {
            setSel(i);
        }
        setOpen(false);
    }

    return (
        <SidebarContext.Provider value={{
            open,
            setOpen,
            sel,
            setSel
        }}>
            <div className="drawer">
                <input checked={open} readOnly type="checkbox" className="drawer-toggle" />
                <div className="drawer-content">
                    {/* Page content here */}

                    {menu[sel].element !== undefined ? menu[sel].element : children}

                </div>
                <div className="drawer-side z-[1]">
                    <label onClick={() => setOpen(false)} aria-label="close sidebar" className="drawer-overlay"></label>
                    <div className="bg-base-300 text-base-content min-h-full w-72 p-4 z-[1] border-r border-r-[#ffffff33]">
                        <ul className="menu w-full">
                            {menu.map((v, i) => (
                                <li key={`side-menu-${i}`}>{v.label}<span onClick={() => Sel(i)} className={cn(
                                    "rounded-full py-4",
                                    sel === i && 'menu-active'
                                )}>{v.value}</span></li>
                            ))}
                        </ul>

                        <div className="divider m-0"></div>

                        <p className="text-xs">Labels</p>
                        <ul className="menu w-full">
                            {auth.user?.labels.map(v => (
                                <li key={`usr-lbl-${v.id}`}><span className="py-4 rounded-full"><Tag size={16} /> {v.value}</span></li>
                            ))}
                        </ul>
                    </div>
                    
                </div>
            </div>
        </SidebarContext.Provider>
    );
}